/**
 * W7.3 — a porta do funil no frontend.
 *
 * A mesma build roda na instância COMERCIAL e na instância do CLIENTE. No
 * cliente, uma tela de preço de SaaS não é bug de UI: é o cliente descobrindo
 * quanto custa o que já comprou e por quanto o vizinho compra. Até hoje a
 * proteção era ACIDENTAL — a imagem do cliente é antiga e não tem o funil.
 * No próximo deploy o funil vai junto.
 *
 * Por isso a flag NASCE DESLIGADA e só liga com um "true" explícito: build que
 * ninguém configurou não tem vitrine. A ausência de configuração nega, não
 * permite — mesma doutrina do backend (`FUNIL_PUBLICO_HABILITADO`, default
 * false, em `core/config.py`).
 *
 * FLAG DE BUILD, não de runtime. O Vite substitui `import.meta.env.*` por
 * literal no bundle: trocar a variável no contêiner NÃO muda nada, é preciso
 * REBUILDAR a imagem. Isto é informação operacional, não detalhe de
 * implementação — está no checklist de lançamento
 * (`docs/operations/CONFIGURACAO-DE-LANCAMENTO.md`).
 *
 * É função, e não constante, para que o valor seja lido na hora da chamada —
 * é isso que deixa o teste provar as duas pontas (ligada e desligada).
 */
export function funilPublicoHabilitado(): boolean {
  const bruto = import.meta.env.VITE_FUNIL_PUBLICO_HABILITADO;
  // Lista de aceitação, não de recusa: qualquer outro valor — vazio, ausente,
  // "false", "0" ou um typo como "ture" — deixa a vitrine FECHADA. Um typo que
  // abre a vitrine na instância do cliente é exatamente o acidente que este
  // módulo existe para impedir.
  return bruto === 'true' || bruto === '1';
}

/**
 * A casa vende por AUTOSSERVIÇO (cartão, checkout, fatura automática)?
 *
 * Hoje não (decisão do ADM, 01/09): a compra é conversa com vendas e a fatura
 * sai à mão. E não é só decisão comercial — é o estado da instalação: não há
 * PSP configurado em produção, então "Faturamento" leva a uma tela que não
 * consegue cobrar ninguém. Aba que promete o que a instalação não faz é pior
 * que aba ausente: o cliente clica, não acontece nada, e ele conclui que o
 * produto está quebrado.
 *
 * Separada de `funilPublicoHabilitado` porque são duas perguntas diferentes, e
 * confundi-las foi o que pôs as duas abas juntas: "existe vitrine de preço?" e
 * "dá para comprar sozinho?". Ligar um PSP responde só a segunda.
 *
 * Mesma doutrina das outras: nasce DESLIGADA, lista de aceitação.
 */
export function compraAutosservicoHabilitada(): boolean {
  const bruto = import.meta.env.VITE_COMPRA_AUTOSSERVICO;
  return bruto === 'true' || bruto === '1';
}
